<template>

  <v-card>
    <v-card-title>
      {{ $t('choose-file-for-upload') }}
    </v-card-title>

    <v-card-text>
      <v-file-input v-model="file" :label="$t('files.select-file')"></v-file-input>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn text @click="ok()">{{ $t('ok') }}</v-btn>
      <v-btn text @click="close()">{{ $t('cancel') }}</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
  export default {
    name: 'file-upload-dialog',

    data () {
      return {
        file: null
      }
    },

    methods: {
      ok () {
        this.$emit('submit', this.file)
      },

      close () {
        this.$emit('submit', false)
      },
    }
  }
</script>

<style scoped lang="scss">

</style>
